import * as types from './types';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';
import { makeOptionsData } from 'Common/FormHelper';

const initalState = {
  statuses: [],
  userOptions: [],
  loading: false,
  error: null,
};

export default (state = initalState, { payload, type }) => {
  switch (type) {
    case types.CHARGES_AND_PREPAYMENTS_GET_USERS:
      const params = {
        keyKey: 'UserId',
        valueKey: 'UserId',
        textKeys: ['UserName'],
      };

      //note that this can't use makeOptionsDataWithAll
      //because we need the ALL value to be -1, not 0
      const userOptions = [
        { value: -1, key: -1, text: 'ALL' },
        ...makeOptionsData(payload, params),
      ];

      return {
        ...state,
        userOptions,
      };

    case types.CHARGES_AND_PREPAYMENTS_REPORT:
      return { ...state, report: payload };

    case types.CHARGES_AND_PREPAYMENTS_SET_STATUS:
      let statuses = [...state.statuses];
      if (payload.checked) {
        statuses.push(payload.status);
      } else {
        statuses = statuses.filter(status => status !== payload.status);
      }
      return {
        ...state,
        statuses,
      };
    case types.CHARGES_AND_PREPAYMENTS_TOGGLE_ALL_STATUSES:
      const statusOptions = Object.values(StatusEnum).reduce(
        (carry, option) => {
          if (option !== '0') {
            carry.push(Number(option));
          }
          return carry;
        },
        []
      );

      if (state.statuses.length < statusOptions.length) {
        statuses = statusOptions;
      } else {
        statuses = [];
      }

      return {
        ...state,
        statuses,
      };
    case types.CHARGES_AND_PREPAYMENTS_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.CHARGES_AND_PREPAYMENTS_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    case types.CHARGES_AND_PREPAYMENTS_FETCHING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/chargesandprepaymentsreport/state/chargesandprepaymentsreport/reducer.js